angular.module('am4').filter('snake', function() {
    return function(value) {
        return (!value) ? '' : value.replace(/ /g, '_');
    };
});


// WEBPACK FOOTER //
// ./src/app/filters/snake.js